module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/250k-active-f616493ad08692fca24de0c4b33eebde.png";